/* eslint react/forbid-prop-types: 0 */
import { PureComponent } from 'react'
import PropTypes from 'meta/PropTypes'
import { ToastContainer } from 'components/display/Toast'
import localStorage from 'connections/localStorage'
import moment from 'moment-timezone'
import getTimeZone from 'lib/getTimeZone'
import context from 'meta/context'
import config from 'meta/config'
import api, { raw } from 'connections/api'
import ErrorMessage from 'components/display/Error'
import Empty from 'components/display/Empty'
import Loader from 'components/display/Loader'
import { IconContext } from 'react-icons'
import { withRouter } from 'react-router-dom'
import analytics from 'connections/analytics'
import Page from 'components/layout/Page'
import { goTo, get as getRedirectTo } from 'lib/redirectTo'
import PlatformRoutes from 'routes/platform'
import HubRoutes from 'routes/hub'
import { getHashValue } from 'lib/qs'
import './index.scss'
import { has } from 'lodash'

const iconProps = { style: { verticalAlign: 'middle' } }

const getPlace = (user) => {
  if (!user) return
  if (user.places.length === 0) return
  const storedId = localStorage.getItem('placeId')
  if (storedId === 'personal-account') return // on personal acc
  const place = storedId && user.places.find(({ id }) => id === storedId)
  if (!place && user.places.length === 0) return
  return place || user.places[0]
}

@context([ 'place', 'login' ])
@withRouter
export default class Root extends PureComponent {
  static propTypes = {
    place: PropTypes.place,
    location: PropTypes.location.isRequired,
    login: PropTypes.func.isRequired
  }
  state = {
    loading: true,
    error: null,
    errorInfo: {},
    isSharingInsightPage: false
  }
  UNSAFE_componentWillMount = async () => {
    this._started = Date.now()
    await this.getAuthState()
  }
  componentDidMount = () => {
    const now = Date.now()
    const render = now - this._started
    if (typeof window.performance !== 'undefined') {
      const perceived = now - performance.timing.navigationStart
      const networkToRender = now - performance.timing.fetchStart
      console.log('Timing', {
        'Navigation to Render': perceived,
        'Network to Render': networkToRender,
        'Ready to Render': render
      })
    } else {
      console.log('Timing', {
        'Ready to Render': render
      })
    }
  }
  componentDidUpdate = (prevProps) => {
    const bothHaveKeys = this.props.location.key && prevProps.location.key
    const keysDiffer = this.props.location.key != prevProps.location.key
    if (bothHaveKeys && keysDiffer) analytics.page()
  }
  componentDidCatch = (error, errorInfo) => {
    console.error('Root caught error!', error, errorInfo)
    this.setState({ error, errorInfo })
  }
  getAuthState = async () => {
    const redir = getRedirectTo()
    let res
    try {
      res = await raw.post('core/auth/state')
    } catch (err) {
      // 401 is fine
      if (err.response?.status === 401) {
        this.setState({ loading: false })
      }
      this.setState({ error: err })
      return
    }

    const body = await res.json()
    await this.setStoreState(body)
    moment.tz.setDefault(getTimeZone())
    this.setState({ loading: false, error: null })
    if (this.props.location.pathname === '/login') return
    if (redir) goTo(redir)
  }
  setStoreState = async (body) => {
    let place = {}
    const user = body?.session?.user
    const isHub = !!body?.hub
    if (body?.hub?.invalid) return goTo(config.paths.public)

    const hashValues = getHashValue(this.props.location)
    if (this.props.location.pathname.includes('/sharing') && has(hashValues, 'placeId')) {
      this.setState({ isSharingInsightPage: true })
      const res = await api.place.findById({ placeId: hashValues?.placeId })
      place = res.body
    } else {
      place = isHub
        ? { ...body.hub.place, isHub: true }
        : getPlace(user)
    }

    if (place) {
      // resolve the boundary and tack it on, its too much BW for the server to do this for all available places
      let { body: boundary } = place.hasMap ? await api.boundary.findById({ boundaryId: place.boundaryId }) : { boundary: null }

      if (place.allStatesBoundaryId) {
        // const uri = `https://boundaries.world/files/${place.allStatesBoundaryId}.geojson`;
        const uri = `https://raw.githubusercontent.com/ranjith-pl/boundaries/feat/country-states/files/${place.allStatesBoundaryId}.geojson`
        const response = await fetch(uri)
        if (response.ok) {
          const area = await response.json()
          boundary = {
            ...boundary,
            area: area,
            hasAllStatesBoundary: true
          }
        }
      }
      this.props.login(user, { ...place, boundary }, this.state.isSharingInsightPage)
    } else {
      this.props.login(user)
    }
  }
  renderMaintenance = () =>
    <Page center title={{ plain: true, title: 'System Maintenance' }}>
      <Empty
        title="Maintenance in progress"
        subtitle="We'll be back up and running as soon as possible!" />
    </Page>
  renderError = () => {
    if (this.state.error?.response?.status >= 500) {
      return this.renderMaintenance()
    }
    return <Page center title={{ plain: true, title: 'Error', statusCode: 500 }}>
      <ErrorMessage
        error={this.state.error}
        errorInfo={this.state.errorInfo} />
    </Page>
  }
  renderContent = () => {
    if (this.state.error) return this.renderError()
    if (this.state.loading) {
      return <Page center>
        <Loader />
      </Page>
    }

    return this.props.place?.isHub ? HubRoutes : PlatformRoutes
  }
  render = () =>
    <IconContext.Provider value={iconProps}>
      {this.renderContent()}
      <ToastContainer />
    </IconContext.Provider>
}
